import React from 'react';
import { QuantityBadge } from '@components/common/QuantityBadge';
import { Dropdown, Icon, ToolbarButton } from '@fourthwall/components';
import { DotsHorizontalIcon, PlaceholderPhotoIcon } from '@fourthwall/icons';
import * as S from './styled';
export const SeriesCell = ({ title, quantity, thumbnailUrl, options }) => (React.createElement(S.Container, null,
    React.createElement(S.ThumbnailContainer, null,
        quantity > 0 ? React.createElement(QuantityBadge, { quantity: quantity }) : null,
        thumbnailUrl ? (React.createElement(S.Thumbnail, { src: thumbnailUrl })) : (React.createElement(Icon, { component: PlaceholderPhotoIcon, height: 32 }))),
    title,
    options && options.length > 0 && (React.createElement(S.Options, null,
        React.createElement(Dropdown, { content: options.map(({ label, onClick }) => (React.createElement(Dropdown.Item, { key: label, label: label, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClick();
                } }))), position: "bottom-end" },
            React.createElement(ToolbarButton, { icon: DotsHorizontalIcon }))))));
